// src/hooks/useVendor.ts

import { useState, useEffect } from 'react';
import { vendorAPI } from '../api/vendor';
import type { Vendor } from '../types';

export const useVendor = () => {
    const [vendor, setVendor] = useState<Vendor | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        fetchVendor();
    }, []);

    const fetchVendor = async () => {
        setLoading(true);
        try {
            const data = await vendorAPI.getVendorProfile();
            setVendor(data);
            setError(null);
        } catch (err) {
            setError('Failed to fetch vendor profile');
            console.error('Failed to fetch vendor:', err);
        } finally {
            setLoading(false);
        }
    };

    const hasMultipleStores = vendor?.stores?.length ? vendor.stores.length > 1 : false;

    return { vendor, loading, error, hasMultipleStores, refetch: fetchVendor };
};